import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeContentComponent } from './home-content/home-content.component';
import { HomeComponent } from './home/home.component';
import { MsalGuard }  from '@azure/msal-angular';
import { OverageComponent } from './overage/overage.component';


const routes: Routes = [
  {
    path: 'overage',
    component: OverageComponent,
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'RefineryHome',
    component: HomeContentComponent,
    canActivate: [
      MsalGuard
    ],
    data: {
      expectedGroups: [],
      title: 'Donges',
      breadcrumb: [
        {
          label: 'RefineryHome',
          url: 'RefineryHome'
        }
      ]
    }
  },
  {
    path: 'Admin',
    component: HomeComponent,
    data: {
      breadcrumb: "Dashboard"
    }
  },
  {
    path: '**',
    redirectTo: 'RefineryHome',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
